import { oz } from '@weft/utils';
import { CurrencySchema } from '../primitives';

export const PriceSchema = oz.object({
  amount: oz.number(),
  currency: CurrencySchema,
});

export type Price = oz.TypeOf<typeof PriceSchema>;